// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__24Wcr","modalForm":"UpgradeEpcsModal_modalForm__2zyUT","modalFooter":"UpgradeEpcsModal_modalFooter__rrURq"};